






























































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import StarRating from 'vue-star-rating';
import {
  AppUserFilter,
  ProjectFilter,
  ProjectTaskFilter, ProjectTaskSelectListForProjectQuery,
  ProjectTimeEntryViewModel,
  RateRuleAmountFilter,
  StSelectListItem,
  StSelectListItemGroup,
  TagFilter,
  TagViewModel,
  TimeEntryEditModel,
  TimeEntryModeEnum,
  TimeEntryPauseRuleModel,
  TimeEntryTypeEnum
} from '@/services/api/nswag/stapiclient_generated';
import {
  stAppUserApi,
  stProjectApi,
  stProjectTaskApi,
  stRateRuleApi,
  stStopwatchApi,
  stTagApi,
  stTimeEntryApi
} from '@/services/st-api';
import { UserStore } from '@/store/user-module';
import StSelect from '@/components/basic/StSelect.vue';
import SlideIn from '@/components/basic/SlideIn.vue';
import { notifyBudget, notifySuccess } from '@/utlitities/notifications';
import StInput2 from '@/components/basic/StInput2.vue';
import StTextarea from '@/components/basic/StTextarea.vue';
import StDurationPicker from '@/components/basic/StDurationPicker.vue';
import { DateTime } from 'luxon';
import StToggle from '@/components/basic/StToggle.vue';
import TimeEntryRateInput from '@/views/TimeEntries/TimeEntryEdit/TimeEntryRateInput.vue';
import DescriptionTextarea from '@/views/TimeEntries/Components/DescriptionTextarea.vue';
import { getHours } from '@/utlitities/helper';
import { TimeEntryStore } from '@/store/time-entry-store';
import StCurrencyInput from "@/components/basic/StCurrencyInput.vue";

@Component({
  components: {
    StCurrencyInput,
    StToggle,
    StDurationPicker,
    StTextarea,
    StInput2,
    SlideIn,
    StSelect,
    TimeEntryRateInput,
    StarRating,
    DescriptionTextarea,
  },
})
export default class TimeEntryEdit extends Vue {
  projects: StSelectListItemGroup[] = [];
  lastProjects: StSelectListItemGroup[] = [];
  projectTasksGrouped: StSelectListItemGroup[] = [];
  users: StSelectListItem[] = [];
  usersWoSelf: StSelectListItem[] = [];
  selectedProject: ProjectTimeEntryViewModel = new ProjectTimeEntryViewModel();
  tags: TagViewModel[] = [];
  pauseRules: TimeEntryPauseRuleModel = TimeEntryPauseRuleModel.fromJS({});
  lastUsedPauseRuleDurationMinutes: number = 0;

  id: number = 0;
  entryDate: string = '';
  timeEntry: TimeEntryEditModel = new TimeEntryEditModel();
  loading: boolean = true;
  saving: boolean = false;
  listPage: string = 'TimeEntries';
  fromList: boolean = false;
  appUserId: number | null = null;
  addFromStopwatch: boolean = false;

  watcher: any;
  delayLoading = false;
  initialized = false;
  entryHasPause = false;
  displayIsBillableChangedWarning = false;

  created() {
    this.id = this.$route.params.id == undefined ? 0 : parseInt(this.$route.params.id);

    const passedEntryDate = this.$route.params.entryDate;
    if (passedEntryDate == 'today') {
      this.entryDate = UserStore.userNowDateTime.toFormat('yyyy-MM-dd');
    } else {
      this.entryDate = this.$route.params.entryDate;
    }

    this.fromList = this.$router.currentRoute.meta.activeGroup == 'postprocess';
    this.appUserId = this.$route.params.appUserId ? parseInt(this.$route.params.appUserId) : null;

    if(this.$route.name == 'TimeEntryAddFromStopwatch'){
      this.addFromStopwatch = true;
    }
  }

  async mounted() {
    try {
      this.loading = true;
      this.openSlideIn();

      await Promise.all([this.loadEditModel(), this.loadProjects(), this.loadLastProjects(), this.loadTags()]);

      await this.loadUsers();

      if (this.appUserId) {
        this.timeEntry.appUserId = this.appUserId;
      }

      await this.loadPauseRules();

      this.entryHasPause = !!this.timeEntry.durationMinutesPause;

      //TODO: im Backend bei den TimeEntryPresets die "forbiddenProject" beachten.
      if (!this.projects.flatMap((x) => x.items).some((x) => x?.id == this.timeEntry.projectId)) {
        this.timeEntry.projectId = this.projects[0]!.items?.[0].id;
      }

      await this.loadSelectedProject();
      await this.loadProjectTasks();

      if (this.isBillableNotChangeable && this.selectedProject.isBillable != this.timeEntry.isBillable) {
        this.timeEntry.isBillable = this.selectedProject.isBillable;
        this.displayIsBillableChangedWarning = true;
      }

      this.watcher = this.$watch('timeEntry.projectId', async () => {
        try {
          this.delayLoading = true;
          const oldInputType = this.timeEntry.isInputTimeFromTo;
          await this.projectChanged();
          //Input Type wird nur bei neuen Zeiteinträgen dem Projekt angepasst
          if (!this.timeEntry.id) {
            if (this.canSwitchTimeEntryMode) {
              this.timeEntry.isInputTimeFromTo = await stTimeEntryApi.getIsTimeFromToByProject(this.timeEntry.projectId!);
            }
            if (oldInputType != this.timeEntry.isInputTimeFromTo && this.timeEntry.isInputTimeFromTo) {
              this.timeEntry.timeFrom = '00:00';
              this.timeEntry.timeTo = getHours(this.timeEntry.durationMinutes ?? 0);
            }
          }

          this.timeEntry.projectTaskId = this.selectedProject.preselectedProjectTaskId;
        } finally {
          this.delayLoading = false;
        }
      });

      await this.$nextTick();
      this.initialized = true;
    } finally {
      this.loading = false;
    }
  }

  get myself() {
    return !TimeEntryStore.selectedUserId || UserStore.currentUser.id == TimeEntryStore.selectedUserId;
  }

  get useLastProjects() {
    return UserStore.userSettings.featureFlagLastUsedProjects;
  }

  get restrictDateFrom() {
    return UserStore.userSettings.restrictDateFrom;
  }

  get restrictDateTo() {
    return UserStore.userSettings.restrictDateTo;
  }

  get useProjectTimeTracking() {
    return this.id == 0 ? !UserStore.userSettings.useBasicTimeTracking && !UserStore.currentUser.isBasicTimeTrackingUser : !this.timeEntry.isBasicTimeEntry;
  }

  get usePauseAtTimeEntry() {
    return (UserStore.usePauseAtTimeEntry || this.entryHasPause) && this.timeEntry.isInputTimeFromTo;
  }

  get durationHours() {
    return getHours(this.timeEntry.durationMinutes ?? 0);
  }

  get canSwitchTimeEntryMode() {
    return UserStore.userSettings.timeEntryMode == TimeEntryModeEnum.DurationAndTimeFromTo;
  }

  async loadPauseRules() {
    if (UserStore.userSettings.enforcePauseRules) {
      this.pauseRules = await stTimeEntryApi.getPauseRules(this.timeEntry.appUserId!);
      this.calculatePause();
    }
  }

  async loadEditModel() {
    if(this.addFromStopwatch){
      this.timeEntry = await stStopwatchApi.stopAndGetTimeEntryEditModel();
    }else{
      this.timeEntry = this.id == 0 ? await stTimeEntryApi.getNew(TimeEntryTypeEnum.TimeEntry, this.entryDate) : await stTimeEntryApi.get(this.id);
    }

  }

  async loadProjects() {
    this.projects = await stProjectApi.getSelectListForTimeTracking();
  }

  async loadLastProjects() {
    this.lastProjects = await stProjectApi.getSelectListOnlyLastUsed(5, false);
  }

  async loadTags() {
    this.tags = await stTagApi.getListForTimeEntry(this.id);
  }

  async loadUsers() {
    if ((this.fromList && this.canEditTimeEntriesForEmployees) || this.showAdditionalInsertAppUserSelect) {
      this.users = await stAppUserApi.getSelectListForListTimeEntry(this.timeEntry.appUserId ?? 0);
    }

    if (this.showAdditionalInsertAppUserSelect) {
      this.usersWoSelf = this.users.filter((x) => x.id != UserStore.currentUser.id);
    }
  }

  beforeDestroy() {
    this.watcher();
  }

  submitForm() {
    (this.$refs.timeEntryForm as any).handleSubmit(this.submit);
  }

  get showAdditionalInsertAppUserSelect() {
    return this.canEditTimeEntriesForEmployees && this.userSettings.showAdditionalInsertAppUserSelect;
  }

  get userSettings() {
    return UserStore.userSettings;
  }

  get hasRates() {
    return this.userSettings.hasRates;
  }

  get isBillableNotChangeable() {
    return this.userSettings.timeEntryIsBillableNotChangeable;
  }

  get useRateRules() {
    return UserStore.userSettings.useRateRules;
  }

  get canViewRates() {
    return UserStore.userSettings.CanViewRates && !UserStore.userSettings.noRates;
  }

  get extraFields() {
    return this.timeEntry.timeEntryExtraFields;
  }

  get selectedProjectHasTasks() {
    return this.selectedProject.hasProjectTasks;
  }

  get canEditTimeEntriesForEmployees() {
    return UserStore.userSettings.CanEditTimeEntriesForEmployees;
  }

  get rateRuleAmountFilter() {
    return RateRuleAmountFilter.fromJS({
      customerId: undefined,
      projectId: this.timeEntry.projectId,
      projectTaskId: this.timeEntry.projectTaskId,
    });
  }

  openSlideIn() {
    (this.$refs.slideIn as SlideIn).open();
  }

  closeSlideIn() {
    (this.$refs.slideIn as SlideIn).close();
  }

  slideOutClosed() {
    if (this.$router.currentRoute.meta.activeGroup == 'postprocess') {
      this.$router.push({ name: 'List' });
    } else {
      this.$router.push({ name: this.listPage });
    }
  }

  toggleIsInputTimeFromTo() {
    this.timeEntry.isInputTimeFromTo = !this.timeEntry.isInputTimeFromTo;
    this.timeChanged('timeTo');
  }

  async loadSelectedProject() {
    if (!this.timeEntry?.projectId) {
      return;
    }

    this.selectedProject = await stProjectApi.getTimeEntryViewModel(this.timeEntry.projectId);
  }

  async loadProjectTasks() {
    this.projectTasksGrouped = await stProjectTaskApi.getSelectListForProject(
      ProjectTaskSelectListForProjectQuery.fromJS({
        projectId: this.selectedProject.id!
      })
    );
  }

  async submit() {
    if (this.saving) {
      return;
    }

    try {
      this.saving = true;
      await this.$nextTick();
      if (this.timeEntry.id == 0) {
        await stTimeEntryApi.post(this.timeEntry);
      } else {
        await stTimeEntryApi.put(this.timeEntry.id, this.timeEntry);
      }

      notifySuccess('Erfolgreich gespeichert');

      if (UserStore.userSettings.showConsumedBudgetOnSave && this.useProjectTimeTracking) {
        const budget = await stProjectApi.getBudgetConsumption(this.timeEntry.projectId!);
        if (budget) {
          notifyBudget(budget);
        }
      }

      this.closeSlideIn();
    } finally {
      this.saving = false;
    }
  }

  async projectChanged() {
    await this.loadSelectedProject();
    await this.loadProjectTasks();

    this.timeEntry.isBillable = this.selectedProject.isBillable;
  }

  calculatePause() {
    const timeFromLuxon = DateTime.fromFormat(this.timeEntry.timeFrom!, 'HH:mm');
    let timeToLuxon = DateTime.fromFormat(this.timeEntry.timeTo!, 'HH:mm');

    if (this.timeEntry.isTwoDayEntry) {
      timeToLuxon = timeToLuxon.plus({ days: 1 });
    }

    let oldDuration = timeToLuxon.diff(timeFromLuxon, ['minutes']).minutes;
    const newDuration = oldDuration - (this.timeEntry.durationMinutesPause ?? 0);

    if (newDuration < 0) {
      this.timeEntry.durationMinutesPause = 0;
      this.timeEntry.durationMinutes = oldDuration;
    } else {
      this.timeEntry.durationMinutes = newDuration;
    }

    if (!this.timeEntry.durationMinutes) {
      this.timeEntry.durationMinutes = 0;
    }

    this.enforcePauseRules();
  }

  enforcePauseRules() {
    if (!this.pauseRules.appUserId || this.timeEntry.isTwoDayEntry || this.timeEntry.durationMinutes == 0) {
      return;
    }
    const timeFromLuxon = DateTime.fromFormat(this.timeEntry.timeFrom!, 'HH:mm');
    const timeToLuxon = DateTime.fromFormat(this.timeEntry.timeTo!, 'HH:mm');

    const duration = timeToLuxon.diff(timeFromLuxon, ['minutes']).minutes;

    const singleRule = this.pauseRules.pauseSingleRules?.find((x) => {
      return x.durationMinutesFrom! <= duration && x.durationMinutesTo! >= duration;
    });

    if (singleRule) {
      if (
        (this.timeEntry.durationMinutesPause ?? 0) < singleRule.durationMinutesMinPause! ||
        (this.timeEntry.durationMinutesPause ?? 0) == this.lastUsedPauseRuleDurationMinutes
      ) {
        this.timeEntry.durationMinutesPause = singleRule.durationMinutesMinPause!;
        this.timeEntry.durationMinutes = duration - this.timeEntry.durationMinutesPause;
        this.lastUsedPauseRuleDurationMinutes = this.timeEntry.durationMinutesPause;
      }
    }
  }

  //TODO: Duplicated in PauseEntry
  timeChanged(type: string) {
    if (!this.timeEntry?.timeFrom || !this.timeEntry?.timeTo) {
      return 0;
    }

    let timeFromLuxon = DateTime.fromFormat(this.timeEntry.timeFrom!, 'HH:mm');
    let timeToLuxon = DateTime.fromFormat(this.timeEntry.timeTo!, 'HH:mm');
    const wasTwoDayEntryBeforeTimeChange = this.timeEntry.isTwoDayEntry;

    if (type == 'timeFrom') {
      if (timeFromLuxon.toMillis() > timeToLuxon.toMillis() && !wasTwoDayEntryBeforeTimeChange) {
        this.timeEntry.timeTo = this.timeEntry.timeFrom;
      }
      if (wasTwoDayEntryBeforeTimeChange && timeFromLuxon.toMillis() < timeToLuxon.toMillis()) {
        this.timeEntry.isTwoDayEntry = false;
      }
    } else {
      if (timeToLuxon.toMillis() < timeFromLuxon.toMillis()) {
        this.timeEntry.isTwoDayEntry = true;
      } else {
        this.timeEntry.isTwoDayEntry = false;
      }
    }

    if (this.timeEntry.isTwoDayEntry) {
      timeToLuxon = timeToLuxon.plus({ days: 1 });
    }

    this.timeEntry.durationMinutes = timeToLuxon.diff(timeFromLuxon, ['minutes']).minutes;

    if (!this.timeEntry.durationMinutes) {
      this.timeEntry.durationMinutes = 0;
    }

    this.calculatePause();
  }
}
